import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { useBoundValue } from "lib/@components/binding/use-bound-value"
import { useDialog } from "lib/@hooks/useDialog"
import { getAuthoringScheduleGroups } from "authoring/routes/project/controller/get-authoring-schedule-groups"
import { GroupSelectorDialog } from "./group-selector-dialog"
import { IconButton, InputAdornment, TextField } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"

export function ScheduleGroupsAutocomplete({ sx }) {
    const { editMode = true } = useBoundContext()
    const scheduleGroups = getAuthoringScheduleGroups.useResultsOnce() ?? []
    const [selectedIds, setSelectedIds] = useBoundValue("legacyScheduleGroups", [])

    const openGroupDialog = useDialog(<GroupSelectorDialog />, { maxWidth: "sm", fullWidth: true })

    const selectedGroups = (selectedIds ?? []).map((id) => scheduleGroups.find((g) => g.id === id)).filter(Boolean)
    const displayText = selectedGroups.map((g) => g.name).join(", ")
    const hasSelection = selectedGroups.length > 0

    return (
        <TextField
            sx={{ mt: 2, ...sx }}
            label="Schedule Groups"
            value={displayText}
            fullWidth
            InputLabelProps={{ shrink: true }}
            disabled={!editMode}
            required
            error={!hasSelection}
            helperText={!hasSelection ? "Is required" : ""}
            InputProps={{
                readOnly: true,
                endAdornment: (
                    <InputAdornment position="end">
                        <IconButton
                            aria-label="Select groups"
                            onClick={handleSelectGroups}
                            disabled={!editMode}
                            edge="end"
                            data-cy="select-groups-button"
                        >
                            <Iconify icon="mdi:folder-open-outline" />
                        </IconButton>
                    </InputAdornment>
                ),
            }}
        />
    )

    async function handleSelectGroups() {
        const result = await openGroupDialog({ initialSelection: selectedIds ?? [], scheduleGroups })
        if (result !== undefined) setSelectedIds(result)
    }
}
